var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_vm._v(" в разработке ")])
}
var staticRenderFns = []

export { render, staticRenderFns }